let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9hhnU")).then(() => parcelRequire('6qyMq'));